import React from 'react';

interface IEllipseContainer {
    children?: React.ReactNode;
    maxWidth?: number
}

export const EllipseContainer: React.FC<IEllipseContainer> = ({ children, maxWidth }) => {
    return (
        <div
            style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth,
            }}
        >
            {children}
        </div>
    );
};
